// <script src="//shopfy-features.myshopify.com/cdn/shop/t/2/assets/bq__yopose.js" defer></script>
console.log('free palestine')